export default __webpack_public_path__ + "static/media/bedKlein.31bb481b.jpg";